<template>
<section class="box root display-pc">
  <com-h1 class="light" title="他们这么评价 ArchSummit"></com-h1>
  <section class="frame-wrap">
    <section class="frame video show-video" @click="playVideo">
      <div class="wrap">
        <h1>大咖</h1>
        <h2>Leading Architects talk about <br>ArchSummit</h2>
        <i></i>
      </div>
    </section>
    <section class="frame people">
      <h1>参会者</h1>
      <swiper :options="swiperOption" ref="swiper" class="comment-swiper-container">
        <swiper-slide v-for="(comment, index) in comments" :key="index">
          <!-- <p class="comment" @mouseover="hover(true)" @mouseleave="hover(false)">{{comment.intro}}</p> -->
          <p class="comment">{{comment.intro}}</p>
          <p class="author">—— {{comment.author}}</p>
        </swiper-slide>
        <div class="comment-swiper-pagination swiper-pagination" slot="pagination"></div>
      </swiper>
      <div class="qa">
        <div class="left">
          <p class="boss"><router-link :to="'/convince-your-boss'" target="_blank">To Boss：想参加ArchSummit？试试邮件说服Boss吧！</router-link></p>
          <p class="user">To ArchSummit：如有任何意见或建议，欢迎通过公众号留言与我们反馈</p>
        </div>
        <div class="right">
          <img width="100%" src="https://static.geekbang.org/infoq/5a69565fcecef.png?imageView2/0/" alt="">
        </div>
      </div>
    </section>
  </section>
</section>
</template>
<script>
import ComH1 from '@/components/com-h1'
export default {
  components: {
    ComH1
  },
  props: [],
  data () {
    return {
      swiperOption: {
        effect: 'slide',
        loop: false,
        autoplay: true,
        speed: 1000,
        fade: {
          crossFade: true
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplayDisableOnInteraction: false
      }
    }
  },
  computed: {
    comments () {
      return [{
        author: '智融集团架构师 任鹏华',
        intro: 'ArchSummit 作为国内比较不错的技术盛会，每年都保持着对它的重点关注。今年第一次到现场观摩学习，不论是大会的组织方式还是讲师分享的内容都给我留下了很深刻的印象，有些主题还刚好是我们在研究的方向，在台下听着就非常有共鸣感。'
      }, {
        author: '爱奇艺技术经理 王天兴',
        intro: '见到了传说中的大牛，听到了大牛对业界趋势的解读，学习到了同行们在实践中的经验与教训，不虚此行。大爱“数据库架构”专题，每场都很精彩；其他的专题也干货满满。'
      }, {
        author: '美丽联合集团技术服务经理 赵成',
        intro: '从大会规模、专题设置、演讲质量、会议组织以及业界受关注程度，整体感受ArchSummit仍然是国内最顶级的架构师峰会，没有之一。大会专题的设置基本就是业界技术发展的风向标，也成了我个人了解技术发展动态很重要的一个渠道。'
      }, {
        author: '滴滴架构师 陈宜明',
        intro: '自己也在参加演讲，对自己所做的工作做了全方位的总结，初学了如何做演讲，演讲时的发挥还算过得去。作为参会听众，通过ArchSummit了解到了业界关注的重点，也进一步了解到了业界的实现思路、以及一些先进的落地方式。'
      }, {
        author: '拍拍贷技术中心框架研发部总监 杨波',
        intro: '这次参会最大的收获是能够与业界同行直接交流，在相关的领域能够互相了解和借鉴经验，受益很大。同时也能够扩展视野，知道业界同行目前的发展水平和工作方向。'
      }]
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    // hover (hover) {
    //   hover ? this.$refs.swiper.swiper.stopAutoplay() : this.$refs.swiper.swiper.startAutoplay()
    // },
    playVideo () {
      this.$emit('play')
    }
  },
  filters: {
  }
}
</script>
<style lang="sass" scoped>
@import "../../style/variable"
.swiper-slide
  box-sizing: border-box
.root
  background-color: $primary
  $colorBlue: #246bb0
  height: 720px
  padding-top: 60px
  background-color: rgb(31,99,175)
  .frame-wrap
    display: flex
    justify-content: center
    margin-top: 45px
    .frame
      width: 560px
      height: 435px
      margin: 0 19px
      background-color: white
      &.video
        background-image: url('https://static.geekbang.org/archsummit/archsummit2017sz-home-comment-bg.jpg')
        background-position: center
        background-size: cover
        color: #fff
        text-align: center
        cursor: pointer
        padding-top: 35px
        position: relative
        .wrap
          width: 100%;height: 100%
          opacity: 0.7
          transition: opacity 0.4s
        &:hover .wrap
          opacity: 1
        h1
          font-size: 28px
          letter-spacing: 20px
        h2
          font-size: 24px
          line-height: 1.4
          margin-top: 10px
        i
          position: absolute
          left: 50%
          top: 50%
          $size: 100px
          width: $size
          height: $size
          margin-left: -$size/2
          margin-top: -$size/2
          background-image: url('https://static.geekbang.org/archsummit/2017sz-logo-start-big.svg')
          background-size: contain
          background-position: center
          background-repeat: no-repeat
      &.people
        overflow: hidden
        padding-top: 32px
        > h1
          line-height: 1
          font-size: 28px
          text-align: center
          margin-bottom: 20px
        .swiper-slide
          font-size: 16px
          padding: 0 30px
          color: #777
          p
            line-height: 1.8
          .comment
            height: 120px
          .author
            text-align: right
        .comment-swiper-pagination
          bottom: 0
          position: relative
          line-height: 1
          margin-top: 20px
          text-align: center
        .qa
          display: flex
          align-items: center
          justify-content: space-between
          margin-top: 33px
          border-top: 1px solid #ccc
          padding: 10px 30px 0 30px
          .boss
            color: $primary
            line-height: 1.4
            margin-top: 5px
          .user
            line-height: 1.4
            margin-top: 10px
            color: #777
          .right
            $size: 110px
            width: $size
            height: $size
            margin-left: 38px
            flex-shrink: 0
</style>
